import { render, staticRenderFns } from "./RBAC.vue?vue&type=template&id=32f917b2&scoped=true"
import script from "./RBAC.vue?vue&type=script&lang=js"
export * from "./RBAC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f917b2",
  null
  
)

export default component.exports